import React from 'react';


const HamburgerMenuIcon = ({ isOpen, toggleMenu }) => {
    return(
        <div className={`menu-icon ${isOpen ? 'open' : ''}`} onClick={toggleMenu}>
            <div className="bar 1"></div>
            <div className="bar 2"></div>
            <div className="bar 3"></div>
        </div>
    );
};

export default HamburgerMenuIcon;